import { useContext } from 'react';
import { VerificationContext } from './VerificationContextValue';

export const useVerification = () => {
    const context = useContext(VerificationContext);
    if (!context) throw new Error('useVerification must be used within a VerificationProvider');
    return context;
};
